// extracted by mini-css-extract-plugin
module.exports = {"badge":"CertifiedDispersionBadge_badge__2H3gJ"};